<template>
  <div>
    <PrimaryButton light @click.native="openDialog" shrink>
      Edit
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <EditLanguagesAndSkillsDialog
      :isOpen="isDialogOpen"
      @close="closeDialog"
      v-if="isDialogOpen"
    />
  </div>
</template>

<script>
import EditLanguagesAndSkillsDialog from "@/views/settings/components/dialogs/EditLanguagesAndSkillsDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  name: "EditLanguagesAndSkillsAction",
  components: { PrimaryButton, EditLanguagesAndSkillsDialog },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>

<style scoped></style>
